const ProgrammeStates = {
  UNKNOWN: "Unknown",
  NOT_ENROLLED: "NotEnrolled",
  CONTENT_AVAILABLE: "UnwatchedContentAvailable",
  WAITING_UNLOCK: "WaitingForNextStepToUnlock",
  COMPLETE: "ProgrammeComplete",
};

export default ProgrammeStates;
